export default __webpack_public_path__ + "static/media/undercvr-pepe.7cc37264.jpeg";